(() => {
  const mount = (root) => {
    root.querySelectorAll('[data-us-carousel]').forEach((carousel) => {
      if (carousel.dataset.usMounted) return;
      const list = carousel.querySelector('.us-creator-list');
      const controls = carousel.querySelector('.us-carousel-controls');
      const previous = carousel.querySelector('[data-us-carousel-prev]');
      const next = carousel.querySelector('[data-us-carousel-next]');
      if (!list || !controls || !previous || !next) return;
      carousel.dataset.usMounted = 'true';
      const update = () => {
        const max = list.scrollWidth - list.clientWidth;
        controls.hidden = max < 4;
        previous.disabled = list.scrollLeft < 4;
        next.disabled = list.scrollLeft >= max - 4;
      };
      const move = (direction) => {
        const card = list.querySelector('.us-creator-card');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).gap) : list.clientWidth;
        list.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      list.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
      else window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
